import { Link } from "react-router";
import { routes } from "../routes";

const footerLinks = [
  { label: "About", to: routes.about },
  { label: "Community Wall", to: routes.wall },
  { label: "Articles", to: routes.articles },
  { label: "Disclaimer", to: routes.disclaimer },
  { label: "Privacy", to: routes.privacy },
  { label: "Terms", to: routes.terms },
];

const styleLinks = [
  { label: "Ghibli Art", to: routes.styleLanding("ghibli") },
  { label: "Kawaii Chibi", to: routes.styleLanding("kawaii") },
  { label: "3D Animation", to: routes.styleLanding("toon3d") },
  { label: "Plushie Doll", to: routes.styleLanding("plushie") },
  { label: "Graphic Stylized", to: routes.styleLanding("cartoon") },
  { label: "Christmas Card", to: routes.styleLanding("christmas") },
  { label: "Christmas Ornament", to: routes.styleLanding("ornament") },
];

// Discover article slugs at build-time
const mdPaths = Object.keys(
  import.meta.glob("/src/articles/*.md", { query: "?raw", eager: true }),
);
const articleLinks = mdPaths.map((p) => {
  const slug = p.replace("/src/articles/", "").replace(".md", "");
  const label = slug.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  return { label, to: routes.article(slug) };
});

export function Footer() {
  return (
    <footer className="border-t border-slate-100 bg-white">
      <div className="mx-auto max-w-[1400px] px-6 py-12">
        {/* Top row */}
        <div className="flex flex-col gap-10 md:flex-row md:justify-between">
          {/* Brand */}
          <div className="max-w-xs">
            <Link to={routes.home} className="inline-block">
              <img
                src="/images/logo-colored.svg"
                alt="Ghibgen"
                width={44}
                height={44}
              />
            </Link>
            <p className="mt-3 text-sm text-slate-500">
              Turn your photos into art worth framing.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap gap-x-12 gap-y-8">
            <div>
              <h4 className="mb-3 text-xs font-bold tracking-wide text-slate-500 uppercase">
                Navigation
              </h4>
              <ul className="space-y-2">
                {footerLinks.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-slate-600 transition-colors hover:text-primary-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="mb-3 text-xs font-bold tracking-wide text-slate-500 uppercase">
                Styles
              </h4>
              <ul className="space-y-2">
                {styleLinks.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-slate-600 transition-colors hover:text-primary-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {articleLinks.length > 0 && (
              <div>
                <h4 className="mb-3 text-xs font-bold tracking-wide text-slate-500 uppercase">
                  Articles
                </h4>
                <ul className="space-y-2">
                  {articleLinks.map((link) => (
                    <li key={link.to}>
                      <Link
                        to={link.to}
                        className="text-sm text-slate-600 transition-colors hover:text-primary-400"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-10 border-t border-slate-100 pt-6 text-center text-xs text-slate-500">
          Ghibgen.com {new Date().getFullYear()} &copy; All rights reserved
        </div>
      </div>
    </footer>
  );
}
